import { defineMessages } from 'react-intl';

export default defineMessages({
    makeLabel: {
        id: 'qnb.spm.manualVehicleLookup.makeLabel',
        defaultMessage: 'Car make'
    },
    modelLabel: {
        id: 'qnb.spm.manualVehicleLookup.modelLabel',
        defaultMessage: 'Car model'
    },
    yearOfRegistrationLabel: {
        id: 'qnb.spm.manualVehicleLookup.yearOfRegistrationLabel',
        defaultMessage: 'Year of registration'
    },
    doorsLabel: {
        id: 'qnb.spm.manualVehicleLookup.doorsLabel',
        defaultMessage: 'Number of doors'
    },
    engineCapacityLabel: {
        id: 'qnb.spm.manualVehicleLookup.engineCapacityLabel',
        defaultMessage: 'Engine size'
    },
    transmissionLabel: {
        id: 'qnb.spm.manualVehicleLookup.transmissionLabel',
        defaultMessage: 'Manual / automatic'
    },
    descriptionLabel: {
        id: 'qnb.spm.manualVehicleLookup.descriptionLabel',
        defaultMessage: 'Description'
    },
    registrationLink: {
        id: 'qnb.spm.manualVehicleLookup.regLink',
        defaultMessage: 'Back to registration'
    },
    blankRegText: {
        id: 'qnb.spm.manualVehicleLookup.blankRegText',
        defaultMessage: 'Don\'t worry, you can still get a quote without the registration'
    },
    descriptionValidation: {
        id: 'qnb.spm.manualVehicleLookup.descriptionValidation',
        defaultMessage: 'Please select the description of your car'
    }
});
